import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";

function Header() {
  return (
    <div
      className="bg-gradient-to-r from-gray-900 to-gray-800 text-white flex flex-col sm:flex-row justify-between items-center px-3 sm:px-4 md:px-6 py-2 sm:py-3"
      data-aos="fade-down"
    >
      {/* LEFT SIDE */}
      <div className="flex flex-col sm:flex-row items-center space-y-1.5 sm:space-y-0 sm:space-x-4 md:space-x-6">

        {/* LOCATION */}
        <div className="flex items-center space-x-1.5 sm:space-x-2 hover:text-gray-300 transition-colors duration-200">
          <MdLocationOn className="text-blue-400 text-sm sm:text-base" />
          <a
            href="https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=17.445805,78.348920&travelmode=driving"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] xs:text-xs sm:text-sm truncate max-w-[200px] sm:max-w-none hover:underline"
          >
            T-hub Phase-2, Hyderabad, 500081
          </a>
        </div>

        {/* EMAIL */}
        <div className="flex items-center space-x-1.5 sm:space-x-2 hover:text-gray-300 transition-colors duration-200">
          <MdEmail className="text-blue-400 text-sm sm:text-base" />
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=Help@orisonservices.in"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[10px] xs:text-xs sm:text-sm truncate max-w-[200px] sm:max-w-none mr-14"
          >
            Help@orisonservices.in
          </a>
        </div>

        {/* PHONE */}
        <div className="flex items-center space-x-1.5 sm:space-x-2 hover:text-gray-300 transition-colors duration-200">
          <MdPhone className="text-blue-400 text-sm sm:text-base" />
          <a
            href="tel:+919876543210"
            className="text-[10px] xs:text-xs sm:text-sm hover:underline"
          >
            +91 7386456106
          </a>
        </div>

      </div>

      {/* RIGHT SIDE - SOCIAL ICONS */}
      <div className="flex space-x-3 sm:space-x-4 text-base sm:text-lg mt-2 sm:mt-0">
        <a href="#" className="hover:text-blue-400 hover:scale-110 transition-all duration-300">
          <FaFacebookF />
        </a>
<a
  href="https://www.instagram.com/orisonservices/"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-pink-400 hover:scale-110 transition-all duration-300"
>
  <FaInstagram />
</a>

<a
  href="https://x.com/Orisonservices"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-blue-300 hover:scale-110 transition-all duration-300"
>
  <FaTwitter />
</a>


        <a href="#" className="hover:text-blue-500 hover:scale-110 transition-all duration-300">
          <FaLinkedinIn />
        </a>
      </div>

    </div>
  );
}

export default Header;
